(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function withWidth(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(p, currency) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var media = img
      ? '<img class="rc__img" src="' + withWidth(img, 480) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
      : '<div class="rc__img"></div>';
    var price = '<span class="rc__price">' + money(p.price, currency) + '</span>';
    var compare = (p.compare_at_price && p.compare_at_price > p.price)
      ? ' <span class="rc__price rc__price--was">' + money(p.compare_at_price, currency) + '</span>'
      : '';
    return (
      '<a class="rc__card" role="listitem" href="' + p.url + '">' +
        '<div class="rc__media">' + media + '</div>' +
        '<span class="rc__name">' + escapeHtml(p.title) + '</span>' +
        '<span class="rc__prices">' + price + compare + '</span>' +
      '</a>'
    );
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-rc-track]');
    var nav = root.querySelector('[data-rc-nav]');
    var prev = root.querySelector('[data-rc-prev]');
    var next = root.querySelector('[data-rc-next]');
    var productId = root.getAttribute('data-product-id');
    var limit = root.getAttribute('data-limit') || 10;
    var base = root.getAttribute('data-recommendations-url') || '/recommendations/products';
    var currency = root.getAttribute('data-currency') || 'EUR';

    var url = base + '.json?product_id=' + productId + '&limit=' + limit + '&intent=related';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { root.style.display = 'none'; return; }
        track.innerHTML = products.map(function (p) { return cardHTML(p, currency); }).join('');
        if (nav && track.scrollWidth > track.clientWidth + 4) nav.hidden = false;
      })
      .catch(function () { root.style.display = 'none'; });

    function scrollByAmount(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByAmount(-1); });
    if (next) next.addEventListener('click', function () { scrollByAmount(1); });
  }

  function boot() {
    document.querySelectorAll('[data-related-carousel]').forEach(function (root) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { initCarousel(root); obs.unobserve(root); }
          });
        }, { rootMargin: '300px' });
        io.observe(root);
      } else {
        initCarousel(root);
      }
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
